exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test-project-package-actions-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  right: 0px;\n  top: 20%;\n}\n", ""]);

// exports
